import { render, staticRenderFns } from "./TypeformEmbed.vue?vue&type=template&id=407ecfae&scoped=true"
import script from "./TypeformEmbed.vue?vue&type=script&lang=js"
export * from "./TypeformEmbed.vue?vue&type=script&lang=js"
import style0 from "./TypeformEmbed.vue?vue&type=style&index=0&id=407ecfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ecfae",
  null
  
)

export default component.exports